import { render, staticRenderFns } from "./GuppyChatButtonApp.vue?vue&type=template&id=ee649b38&"
import script from "./GuppyChatButtonApp.vue?vue&type=script&lang=js&"
export * from "./GuppyChatButtonApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports